export function navigation() {

    'use strict';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function Navigation(options) {
        this.Init(options);
    }

    Navigation.prototype = {

        /**
         * Constructor
         * @Param object options
         * @return void
         */
        Init: function (options) {

            this.options = Object.assign({
                navs: '.js-navigation',
            }, options);

            this.navs = document.querySelectorAll(this.options.navs);

            this.Start();
        },

        Start: function () {

            const _this = this;
            const navs = this.navs;

            navs.forEach(function(nav) {
                const menus = nav.querySelectorAll('ul[data-level]');
                const items = nav.querySelectorAll('.navigation__item');
                const dropdowns = nav.querySelectorAll('.navigation__dropdown');
                const controls = nav.querySelectorAll('button.navigation__item[aria-controls]');
                let duration = nav.getAttribute('data-menu-duration');
                controls.forEach(function(control) {
                    control.setAttribute('aria-expanded', 'false');
                });
                dropdowns.forEach(function(dropdown) {
                    let submenu = dropdown.querySelector('.navigation__submenu');
                    let navItem = dropdown.querySelector('.navigation__item')
                    if (submenu.querySelectorAll('[aria-current]').length) {
                        navItem.classList.add('aria-current-path');
                    }
                });
                if (duration) {
                    nav.querySelectorAll('ul[data-level]').forEach(function(menu) {
                        menu.style.transitionDuration =  parseInt(duration) + 'ms';
                    });
                }
                _this.SetEvents(nav, menus, items);
            });

        },

        /**
         * SetEvents
         * @return void
         */
        SetEvents: function (nav, menus, items) {

            const _this = this;

            menus.forEach(function(menu) {
                let level = menu.getAttribute('data-level');
                let controls = menu.querySelectorAll(':scope > li > button.navigation__item[aria-controls]');
                let submenus = menu.querySelectorAll('.navigation__submenu.expanded');
                const nav = menu.closest('.js-navigation');
                let duration = parseInt(nav.getAttribute('data-menu-duration'));

                menu.addEventListener('keydown', function (e) {
                    e.stopPropagation();
                    if (e.which === 27 && level > 1) {
                        if (menu.classList.contains('collapsing')) {
                            e.preventDefault();
                        } else {
                            menu.closest('.navigation__dropdown').classList.remove('active');
                            menu.classList.add('collapsing');
                            submenus.forEach(function(submenu) {
                                submenu.classList.add('collapsing');
                            });
                            menu.querySelectorAll('.navigation__item[aria-expanded=true]').forEach(function(item) {
                                item.setAttribute('aria-expanded', 'false');
                            });
                            setTimeout(function () {
                                menu.classList.remove('collapsing', 'expanded');
                                menu.style.display = 'none';
                                submenus.forEach(function(submenu) {
                                    submenu.style.display = 'none';
                                });
                            }, ((reducedMotion.matches || !reducedMotion) ? 0 : duration));
                            nav.querySelector('[aria-controls=' + menu.id + ']').setAttribute('aria-expanded', 'false');
                            nav.querySelector('[aria-controls=' + menu.id + ']').focus();
                        }
                    }
                });

                controls.forEach(function(control) {
                    control.addEventListener('click', function (e) {
                        let target = nav.querySelector('#' + control.getAttribute('aria-controls'));
                        if (target.classList.contains('expanding') || target.classList.contains('collapsing')) {
                            e.preventDefault();
                        } else {
                            fireEvent(control, target);
                        }
                    });
                });

                function fireEvent(control, target) {

                    let submenus = target.querySelectorAll('[data-level]');

                    if (control.getAttribute('aria-expanded') === 'true') {
                        target.classList.add('collapsing');
                        target.closest('.navigation__dropdown').classList.remove('active');

                        target.querySelectorAll('.navigation__item[aria-expanded=true]').forEach(function (item) {
                            item.setAttribute('aria-expanded', 'false');
                        });
                        submenus.forEach(function (submenu) {
                            submenu.classList.add('collapsing');
                            submenu.querySelectorAll('.navigation__item[aria-expanded=true]').forEach(function (submenItem) {
                                submenu.setAttribute('aria-expanded', 'false');
                            });
                        });

                        target.closest('li').querySelector('[aria-controls=' + target.id + ']').setAttribute('aria-expanded', 'false');

                        setTimeout(function () {
                            target.classList.remove('collapsing', 'expanded');
                            target.style.display = 'none';
                            submenus.forEach(function (submenu) {
                                submenu.classList.remove('collapsing', 'expanded');
                                submenu.style.display = 'none';
                            });
                        }, ((reducedMotion.matches || !reducedMotion) ? 0 : duration));

                        control.setAttribute('aria-expanded', 'false');
                    } else {
                        controls.forEach(function(ctrl) {
                            if (ctrl !== control && !ctrl.closest('li.goback')) {
                                ctrl.setAttribute('aria-expanded', 'false');
                            }
                        });
                        control.setAttribute('aria-expanded', 'true');
                        target.querySelector('[aria-controls=' + target.id + ']').setAttribute('aria-expanded', 'true');

                        Array.from(document.querySelectorAll('[data-level]')).forEach(function(element) {
                            if (element.id !== target.id && element.getAttribute('data-level') > parseInt(level) && element.classList.contains('expanded')) {
                                element.classList.add('collapsing');
                                element.closest('.navigation__dropdown').classList.remove('active');
                                Array.from(element.querySelectorAll('.navigation__item[aria-controls]')).forEach(function(item) {
                                    item.setAttribute('aria-expanded', 'false');
                                });
                            }
                        });

                        setTimeout(function () {
                            document.querySelectorAll('[data-level]').forEach(function(element) {
                                if (element.getAttribute('data-level') > parseInt(level) && element.classList.contains('collapsing')) {
                                    element.classList.remove('collapsing', 'expanded');
                                    element.style.display = 'none';
                                    element.querySelectorAll('.navigation__item[aria-expanded=true]').forEach(function(item) {
                                        item.setAttribute('aria-expanded', 'false');
                                    });
                                }
                            });
                        }, ((reducedMotion.matches) ? 0 : duration));

                        target.style.display = 'block'; // Show the target element
                        target.closest('.navigation__dropdown').classList.add('active');
                        setTimeout(function () {
                            target.classList.add('expanding');
                        }, 30)
                        setTimeout(function () {
                            target.classList.add('expanded');
                            target.classList.remove('expanding');
                        }, ((reducedMotion.matches) ? 0 : duration));

                    }
                }

                if (window.innerWidth >= 1024 && nav.getAttribute('data-hover') === 'true') {
                    controls.forEach(function(ctrl) {
                        ctrl.closest('li').addEventListener('mouseenter', function(e) {
                            let control = this.querySelector('button.navigation__item[aria-controls]');
                            let target = document.getElementById(control.getAttribute('aria-controls'));
                            fireEvent(control, target);
                        });

                        ctrl.closest('li').addEventListener('mouseleave', function() {
                            let control = this.querySelector('button.navigation__item[aria-controls]');
                            let target = document.getElementById(control.getAttribute('aria-controls'));
                            target.classList.add('collapsing');
                            control.setAttribute('aria-expanded', 'false');
                            target.closest('.navigation__dropdown').classList.remove('active');
                            setTimeout(function() {
                                target.classList.remove('collapsing');
                                target.classList.remove('expanded');
                                target.style.display = 'none';
                            }, reducedMotion.matches ? 0 : duration);
                        });

                    });
                }

            });

            items.forEach(function(item) {
                item.addEventListener('keydown', function(e) {
                    const keyCode = e.which;
                    let prevSibling = item.previousElementSibling;
                    let nextSibling = item.nextElementSibling;
                    switch (keyCode) {
                        case 32:
                            e.preventDefault();
                            item.click();
                            break;
                        case 35:
                            e.preventDefault();
                            item.closest('ul[data-level]').querySelector('> li:last-child .navigation__item').focus(); //needs to be tested
                            break;
                        case 36:
                            e.preventDefault();
                            item.closest('ul[data-level]').querySelector('> li:first-child .navigation__item').focus(); //needs to be tested
                            break;
                        case 37:
                            e.preventDefault();
                            if (prevSibling && prevSibling.classList.contains('navigation__item')) {
                                prevSibling.focus();
                            } else {
                                prevSibling = item.closest('li').previousElementSibling;
                                if (prevSibling) {
                                    let directChildren = Array.from(prevSibling.querySelectorAll('.navigation__item')).filter(child => child.parentNode === prevSibling);
                                    if (directChildren.length > 0) {
                                        let lastNavItem = directChildren[directChildren.length - 1];
                                        lastNavItem.focus();
                                    } else {
                                        return;
                                    }
                                } else {
                                    return;
                                }
                            }
                            break;
                        case 38:
                            e.preventDefault();
                            if (prevSibling && prevSibling.classList.contains('navigation__item')) {
                                prevSibling.focus();
                            } else {
                                prevSibling = item.closest('li').previousElementSibling;
                                console.log(prevSibling);
                                if (prevSibling) {
                                    let directChildren = Array.from(prevSibling.querySelectorAll('.navigation__item')).filter(child => child.parentNode === prevSibling);
                                    if (directChildren.length > 0) {
                                        let lastNavItem = directChildren[directChildren.length - 1];
                                        lastNavItem.focus();
                                    } else {
                                        return;
                                    }
                                } else {
                                    return;
                                }
                            }
                            break;
                        case 39:
                            e.preventDefault();
                            if (item.getAttribute('aria-expanded') === 'true' && item.closest('ul[data-level]').getAttribute('data-level') !== '1') {
                                const firstNavItem = document.getElementById(item.getAttribute('aria-controls')).querySelector('li:not(.goback) > .navigation__item');
                                if (firstNavItem) {
                                    firstNavItem.focus();
                                }
                            } else  {
                                if (nextSibling && nextSibling.classList.contains('navigation__item')) {
                                    nextSibling.focus();
                                } else {
                                    nextSibling = item.closest('li').nextElementSibling;
                                    if (nextSibling) {
                                        let directChildren = Array.from(nextSibling.querySelectorAll('.navigation__item')).filter(child => child.parentNode === nextSibling);
                                        if (directChildren.length > 0) {
                                            let firstNavItem = directChildren[0];
                                            firstNavItem.focus();
                                        } else {
                                            return;
                                        }
                                    } else {
                                        return;
                                    }
                                }
                            }
                            break;
                        case 40:
                            e.preventDefault();
                            if (item.getAttribute('aria-expanded') === 'true' && item.closest('ul[data-level]').getAttribute('data-level') === '1') {
                                const firstNavItem = document.getElementById(item.getAttribute('aria-controls')).querySelector('li:not(.goback) > .navigation__item');
                                if (firstNavItem) {
                                    firstNavItem.focus();
                                }
                            } else  {
                                let nextSibling = item.nextElementSibling;
                                if (nextSibling && nextSibling.classList.contains('navigation__item')) {
                                    nextSibling.focus();
                                } else {
                                    nextSibling = item.closest('li').nextElementSibling;
                                    if (nextSibling) {
                                        let directChildren = Array.from(nextSibling.querySelectorAll('.navigation__item')).filter(child => child.parentNode === nextSibling);
                                        if (directChildren.length > 0) {
                                            let firstNavItem = directChildren[0];
                                            firstNavItem.focus();
                                        } else {
                                            return;
                                        }
                                    } else {
                                        return;
                                    }
                                }
                            }
                            break;

                    }
                });
            });

        }
    }

    new Navigation();

    return 'navigation';
}
